import React from "react";

class PlazkartPlayer extends React.Component {
    componentDidMount() {
        const {device} = this.props
        if (device === "desktop") {
            const script = document.createElement("script");
            script.defer = true;
            script.src = "https://static.vnadsrv.com/vn_init.js?profileId=8114481&url=https%3A%2F%2Finit.vnadsrv.com%2F%3Finit";
            document.body.append(script);
        }
    }

    render() {
        return null;
    }
}

export default PlazkartPlayer;
